// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  FileCategory,
} from "./types";


export default __t.row({
  fileId: __t.u64().primaryKey().name("file_id"),
  versionId: __t.u64().name("version_id"),
  relativePath: __t.string().name("relative_path"),
  get category() {
    return FileCategory;
  },
  sizeBytes: __t.u64().name("size_bytes"),
  hash: __t.string(),
  chunkCount: __t.u32().name("chunk_count"),
});
